var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.handleCondition()&&_vm.showInEditOrAdd)?_c('el-form-item',{attrs:{"label":`${_vm.config.label}：`,"prop":_vm.config.prop}},[_c(_vm.config.type,{tag:"component",attrs:{"context":_vm.context,"config":_vm.config}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }